if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends HTMLElement {
      constructor() {
        super();
        this.overlay = null;
        this.images = [];
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isFullscreen = false;

        this.onKeyDown = this.onKeyDown.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
      }

      connectedCallback() {
        this.buildLightbox();
      }

      buildLightbox() {
        // Create overlay
        this.overlay = document.createElement('div');
        this.overlay.className = 'product-lightbox-overlay';
        this.overlay.setAttribute('role', 'dialog');
        this.overlay.setAttribute('aria-modal', 'true');
        this.overlay.setAttribute('aria-label', 'Product image lightbox');

        // Close button
        var closeBtn = document.createElement('button');
        closeBtn.className = 'product-lightbox-close';
        closeBtn.setAttribute('aria-label', 'Close lightbox');
        closeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        closeBtn.addEventListener('click', () => this.hide());

        // Prev button
        var prevBtn = document.createElement('button');
        prevBtn.className = 'product-lightbox-nav product-lightbox-nav--prev';
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        prevBtn.addEventListener('click', () => this.prev());

        // Next button
        var nextBtn = document.createElement('button');
        nextBtn.className = 'product-lightbox-nav product-lightbox-nav--next';
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        nextBtn.addEventListener('click', () => this.next());

        // Image element
        this.imageEl = document.createElement('img');
        this.imageEl.className = 'product-lightbox-image';
        this.imageEl.setAttribute('draggable', 'false');

        // Counter
        this.counterEl = document.createElement('div');
        this.counterEl.className = 'product-lightbox-counter';

        this.overlay.appendChild(closeBtn);
        this.overlay.appendChild(prevBtn);
        this.overlay.appendChild(nextBtn);
        this.overlay.appendChild(this.imageEl);
        this.overlay.appendChild(this.counterEl);

        // Close on overlay background click
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) this.hide();
        });

        document.body.appendChild(this.overlay);
      }

      collectImages() {
        var gallery = document.querySelector('media-gallery');
        if (!gallery) return;
        this.images = [];
        var mediaItems = gallery.querySelectorAll('[data-media-id] img');
        mediaItems.forEach((img) => {
          var src = img.src || img.dataset.src || '';
          if (src) {
            // Get the highest resolution version
            var highResSrc = src.replace(/&width=\d+/, '&width=1600');
            this.images.push(highResSrc);
          }
        });
      }

      show(opener) {
        this.collectImages();
        if (this.images.length === 0) return;

        // Determine starting index from opener
        var mediaId = opener ? opener.getAttribute('data-media-id') : null;
        this.currentIndex = 0;

        if (mediaId) {
          var gallery = document.querySelector('media-gallery');
          if (gallery) {
            var allMedia = gallery.querySelectorAll('[data-media-id]');
            allMedia.forEach((el, index) => {
              if (el.getAttribute('data-media-id') === mediaId) {
                this.currentIndex = index;
              }
            });
          }
        }

        this.updateImage();
        this.overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';

        // Bind keyboard events
        document.addEventListener('keydown', this.onKeyDown);

        // Bind touch events
        this.overlay.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.overlay.addEventListener('touchend', this.onTouchEnd, { passive: true });

        // Store opener for focus restoration
        this.openedBy = opener;
      }

      hide() {
        this.overlay.classList.remove('is-active');
        this.overlay.classList.remove('is-fullscreen');
        this.isFullscreen = false;
        document.body.style.overflow = '';

        document.removeEventListener('keydown', this.onKeyDown);
        this.overlay.removeEventListener('touchstart', this.onTouchStart);
        this.overlay.removeEventListener('touchend', this.onTouchEnd);

        // Restore focus
        if (this.openedBy && typeof this.openedBy.focus === 'function') {
          this.openedBy.focus();
        }
      }

      prev() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.updateImage();
      }

      next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.updateImage();
      }

      updateImage() {
        if (this.images.length === 0) return;
        this.imageEl.src = this.images[this.currentIndex];
        this.imageEl.alt = 'Product image ' + (this.currentIndex + 1) + ' of ' + this.images.length;
        this.counterEl.textContent = (this.currentIndex + 1) + ' / ' + this.images.length;

        // Hide nav/counter for single-image products
        var prevBtn = this.overlay.querySelector('.product-lightbox-nav--prev');
        var nextBtn = this.overlay.querySelector('.product-lightbox-nav--next');
        var showNav = this.images.length > 1;
        if (prevBtn) prevBtn.style.display = showNav ? '' : 'none';
        if (nextBtn) nextBtn.style.display = showNav ? '' : 'none';
        this.counterEl.style.display = showNav ? '' : 'none';
      }

      toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen;
        this.overlay.classList.toggle('is-fullscreen', this.isFullscreen);
      }

      onKeyDown(e) {
        switch (e.key) {
          case 'Escape':
            this.hide();
            break;
          case 'ArrowLeft':
            this.prev();
            break;
          case 'ArrowRight':
            this.next();
            break;
          case 'f':
          case 'F':
            this.toggleFullscreen();
            break;
        }
      }

      onTouchStart(e) {
        this.touchStartX = e.changedTouches[0].screenX;
      }

      onTouchEnd(e) {
        this.touchEndX = e.changedTouches[0].screenX;
        var delta = this.touchStartX - this.touchEndX;
        if (Math.abs(delta) > 50) {
          if (delta > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      }

      // Legacy compatibility: showActiveMedia is no longer needed
      // but keep the method in case other code calls it
      showActiveMedia() {
        // no-op in new lightbox mode
      }
    }
  );
}
